// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import dynamicProto from "@microsoft/dynamicproto-js";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import { _DYN_ADD_EVENT, _DYN_CLEAR, _DYN_COUNT, _DYN_ENDPOINT, _DYN_GET_ITEMS, _DYN_LENGTH, _DYN_PUSH, _DYN_SPLICE, _DYN_SPLIT } from "./__DynamicConstants";
var InMemoryBatch = /** @class */ (function () {
    function InMemoryBatch(logger, endpoint, evts, evtsLimitInMem) {
        var _buffer = evts ? [].concat(evts) : [];
        dynamicProto(InMemoryBatch, this, function (_self) {
            _self[_DYN_ENDPOINT /* @min:%2eendpoint */] = function () {
                return endpoint;
            };
            _self[_DYN_ADD_EVENT /* @min:%2eaddEvent */] = function (payload) {
                if (!isNullOrUndefined(evtsLimitInMem) && _self[_DYN_COUNT /* @min:%2ecount */]() >= evtsLimitInMem) {
                    return false;
                }
                _buffer[_DYN_PUSH /* @min:%2epush */](payload);
                return true;
            };
            _self[_DYN_COUNT /* @min:%2ecount */] = function () {
                return _buffer[_DYN_LENGTH /* @min:%2elength */];
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _buffer = [];
            };
            _self[_DYN_GET_ITEMS /* @min:%2egetItems */] = function () {
                return _buffer.slice(0);
            };
            _self[_DYN_SPLIT /* @min:%2esplit */] = function (fromEvt, numEvts) {
                // Create a new batch with the same endpointUrl
                var theEvts;
                if (fromEvt < _buffer[_DYN_LENGTH /* @min:%2elength */]) {
                    var cnt = _buffer[_DYN_LENGTH /* @min:%2elength */] - fromEvt;
                    if (!isNullOrUndefined(numEvts)) {
                        cnt = numEvts < cnt ? numEvts : cnt;
                    }
                    theEvts = _buffer[_DYN_SPLICE /* @min:%2esplice */](fromEvt, cnt);
                }
                return new InMemoryBatch(logger, endpoint, theEvts, evtsLimitInMem);
            };
            _self.createNew = function (newEndpoint, evts, newEvtsLimitInMem) {
                return new InMemoryBatch(logger, newEndpoint, evts, newEvtsLimitInMem);
            };
        });
    }
    InMemoryBatch.prototype.addEvent = function (payload) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    InMemoryBatch.prototype.endpoint = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    InMemoryBatch.prototype.count = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return 0;
    };
    InMemoryBatch.prototype.clear = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    InMemoryBatch.prototype.getItems = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    /**
     * Split this batch into 2 with any events > fromEvent returned in the new batch and all other
     * events are kept in the current batch.
     * @param fromEvt The first event to remove from the current batch.
     * @param numEvts The number of events to be removed from the current batch and returned in the new one. Defaults to all trailing events
     */
    InMemoryBatch.prototype.split = function (fromEvt, numEvts) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    /**
     * create current buffer to a new endpoint
     * @param endpoint if not defined, current endpoint will be used
     * @param evts new events to be added
     * @param addCurEvts if it is set to true, current itemss will be transferred to the new batch
     */
    InMemoryBatch.prototype.createNew = function (endpoint, evts, evtsLimitInMem) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    return InMemoryBatch;
}());
export { InMemoryBatch };
//# sourceMappingURL=InMemoryBatch.js.map